export default {
  name: 'Navbar',
  data() {
    return {
      showMenu: false,
    };
  },
  watch: {
    $route: function () {
      this.showMenu = false;
    },
  },
};
